import React, { useState, useEffect } from "react";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import Draggable from "react-draggable";
import Paper from "@material-ui/core/Paper";
import PropTypes from "prop-types";
import { createMuiTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import { Button, Icon, Dropdown, ButtonGroup } from "semantic-ui-react";

function PaperComponent(props) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

const theme = createMuiTheme({
  direction: "rtl",
});


/**
 * Modal component.
 *
 * Props:
 *
 * @property {string} title - The title of the modal. (Required)
 * @property {function} cancel - Callback function when cancel is clicked. (Required)
 * @property {string} [saveTitle="ثبت"] - Text for the primary save button.
 * @property {function} save - Callback function when the primary save button is clicked. (Required)
 * @property {string} [saveIcon="check"] - Icon name for the primary save button (semantic-ui-react icons).
 * @property {boolean} open - Whether the modal is visible (true = show, false = hide). (Required)
 * @property {string} [otherSaveTitle] - Text for a secondary save button.
 * @property {string} [otherSaveIcon="check"] - Icon name for the secondary save button.
 * @property {function} [otherSave] - Callback function when the secondary save button is clicked.
 * @property {'xs' | 'sm' | 'md' | 'lg' | 'xl'} maxWidth - Maximum width of the modal. (Required)
 * @property {React.ReactNode} children - Modal content, usually a form. (Required)
 * @property {boolean} [dropdown] - Whether the dropdown button is visible.
 * @property {string} [dropdownTitle] - Text of the dropdown button.
 * @property {boolean} [dropdownDisable] - Whether the dropdown button is disabled.
 * @property {Array<{name: string, text: string, value: any}>} [dropdownOptions] - Items for the dropdown button.
 * @property {function} [dropdownOnCLick] - Callback when a dropdown item is clicked; receives the item's value.
 * @property {React.ReactNode} [Buttons] - Additional custom buttons rendered inside the modal.
 *
 * @example
 * const options = [
 *   { text: "Edit", key: "edit", value: { id: 1000, x: "x1" } },
 *   { text: "Delete", key: "delete", value: { id: 1001, x: "x2" } },
 * ];
 *
 * const Buttons = (props) => (
 *   <>
 *     <Button icon labelPosition="right" size="small" color="blue" onClick={props.onDelete}>
 *       Delete Invoice
 *       <Icon name="trash" />
 *     </Button>
 *     <Button icon labelPosition="right" size="small" color="blue" onClick={props.onPrint}>
 *       Print
 *       <Icon name="print" />
 *     </Button>
 *   </>
 * );
 *
 * <Modal
 *   title="Edit User"
 *   cancel={onCancelHandler}
 *   saveTitle="Save"
 *   save={onSaveHandler}
 *   saveIcon="search"
 *   open={modalStatus}
 *   otherSaveTitle="Print"
 *   otherSaveIcon="print"
 *   otherSave={onPrintHandler}
 *   maxWidth="lg"
 *   dropdown={true}
 *   dropdownTitle="Actions"
 *   dropdownDisable={false}
 *   dropdownOnCLick={onDropDownButtonHandler}
 *   dropdownOptions={options}
 *   Buttons={() => <Buttons onDelete={handleDeleteClick} onPrint={handlePrintClick} />}
 * >
 *   ... form content ...
 * </Modal>
 */
const Modal = (props) => {
  // const [open, setOpen] = React.useState(true);
  const { Buttons } = props;
  const [selected, setSelected] = useState({});
  const [title, setTitle] = useState("عملیات");

  useEffect(()=>{
    setTitle(selected.text === undefined ? "عملیات" : selected.text);
  }, [selected])

  const handleChange = (e, { value }) => {
    setSelected(value);
  }

  const handleClick = (e) => {
    // e.preventDefault();
    props.dropdownOnCLick(selected);
  }

  return (
    <ThemeProvider theme={theme}>
      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth={props.maxWidth || "xl"}
        fullWidth={true}
        scroll="body"
        PaperComponent={PaperComponent}
        open={props.open}
        className="modal"
      >
        <DialogTitle id="draggable-dialog-title" className="modal-title" style={{ cursor: "move" }}>
          {props.title}
        </DialogTitle>
        <DialogContent dividers className="modal-content">
          {props.children}
        </DialogContent>
        <DialogActions className="modal-actions">
          {props.dropdown && !props.dropdownDisable ? (<ButtonGroup color='blue' onClick={()=>{handleClick()}} size="small" className="dropdown-btn" style={{ marginLeft: 10 }}>
            <Button>{title}</Button>
            <Dropdown
              onChange={handleChange}
              className='button icon'
              floating
              options={props.dropdownOptions}
              trigger={<></>}
            />
          </ButtonGroup>) : null}
          {props.save ? (
            <Button icon labelPosition="right" color="blue" size="small" onClick={props.save}>
              <Icon name={props.saveIcon ? props.saveIcon : "check"} />
              {props.saveTitle ? props.saveTitle : "تایید"}
            </Button>
          ) : null}
          {props.otherSave ? (
            <Button icon labelPosition="right" color="blue" size="small" onClick={props.otherSave}>
              <Icon name={props.otherSaveIcon ? props.otherSaveIcon : "check"} />
              {props.otherSaveTitle ? props.otherSaveTitle : "تایید"}
            </Button>
          ) : null}
          {Buttons ? <Buttons /> : null}
          <Button icon labelPosition="right" size="small" onClick={props.cancel}>
            انصراف
            <Icon name="close" />
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
};

Modal.propTypes = {
  title: PropTypes.string.isRequired,
  cancel: PropTypes.func.isRequired,
  save: PropTypes.func,
  open: PropTypes.bool.isRequired,
};

export default Modal;
